// src/auth/RequireAccess.tsx
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAccessFeatures } from './useAccessFeatures';
import { requirementForPath, isAllowed } from './routeAccess';

// Route-level gate: resolves the full pathname against ROUTE_ACCESS.
export function RequireAccess({ children }: { children: ReactNode }) {
    const location = useLocation();
    const { role, features, isPending } = useAccessFeatures();

    // Spin only while there is genuinely no result yet. A settled-but-empty
    // identity falls through to the deny below and lands on /no-access, which
    // is recoverable — unlike spinning forever on a terminal failure.
    if (isPending) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress size={24} />
            </Box>
        );
    }

    if (!isAllowed(requirementForPath(location.pathname), role, features)) {
        return <Navigate to="/no-access" replace />;
    }
    return <>{children}</>;
}
